const COUPON_TIME_ZONE = 'America/Mazatlan';

export const formatCouponDate = (dateTime: string, withYear = false) =>
	new Intl.DateTimeFormat('es-MX', {
		day: 'numeric',
		month: 'long',
		...(withYear ? { year: 'numeric' } : {}),
		timeZone: COUPON_TIME_ZONE,
	}).format(new Date(dateTime));

export const formatCouponTime = (dateTime: string) =>
	new Intl.DateTimeFormat('es-MX', {
		hour: '2-digit',
		minute: '2-digit',
		hourCycle: 'h23',
		timeZone: COUPON_TIME_ZONE,
	}).format(new Date(dateTime));

const ONE_DAY_MS = 24 * 60 * 60 * 1000;

const toCouponDay = (date: Date) =>
	new Intl.DateTimeFormat('en-CA', { timeZone: COUPON_TIME_ZONE }).format(date);

export type CouponUrgency = 'today' | 'tomorrow';

export const getCouponUrgency = (
	dateTime?: string,
	now = Date.now()
): CouponUrgency | undefined => {
	if (!dateTime) {
		return undefined;
	}
	const day = toCouponDay(new Date(dateTime));
	if (day === toCouponDay(new Date(now))) {
		return 'today';
	}
	return day === toCouponDay(new Date(now + ONE_DAY_MS)) ? 'tomorrow' : undefined;
};

export const COUPON_URGENCY_SUFFIX: Record<CouponUrgency, string> = {
	today: ', ¡vence hoy!',
	tomorrow: ', ¡vence mañana!',
};

export const COUPON_URGENCY_LINE: Record<CouponUrgency, string> = {
	today: '¡Vence hoy!',
	tomorrow: '¡Vence mañana!',
};

export const getCouponValidityHint = (dateTime?: string) => {
	if (!dateTime) {
		return '';
	}
	return getCouponUrgency(dateTime) ? '' : `Disponible hasta el ${formatCouponDate(dateTime)}*`;
};
